/**
 * Utility functions for RichTextEditor configuration and functionality
 */

/**
 * Creates a configuration object for RichTextEditor with custom paste handling
 * @param {Object} baseConfig - Base configuration to extend
 * @returns {Object} Extended configuration with paste handling
 */
export const createEditorConfig = (baseConfig) => {
  return {
    ...baseConfig,
    onpaste() {
      // Prevent default paste behavior
      return false;
    },
    pasteAsPlainText: true,
    pasteMode: 'Custom',
    pasteTextCleanupMode: 'None',
    pasteTextLinebreakReplacement: '<br>',
  };
};

/**
 * Sets up a custom paste handler for the RichTextEditor
 * @param {Object} editor - The RichTextEditor instance
 */
export const setupPasteHandler = (editor) => {
  if (!editor || !editor.document || !editor.document.body) {
    return;
  }

  const originalPasteHandler = editor.document.body.onpaste;

  editor.document.body.onpaste = function (e) {
    const htmlContent = e.clipboardData.getData('text/html');

    // If HTML content exists, let the editor handle it normally
    if (htmlContent && htmlContent.length > 0) {
      return originalPasteHandler ? originalPasteHandler.call(editor, e) : true;
    }

    const text = e.clipboardData.getData('text/plain');

    if (text && text.includes('\n')) {
      e.preventDefault();
      e.stopPropagation();

      // Process text with line breaks
      let html = '';
      const lines = text.split('\n');

      lines.forEach((line) => {
        if (line.trim() === '') {
          html += '<br>';
        } else {
          html += `${line}<br>`;
        }
      });

      // Remove the last <br> if it exists
      html = html.replace(/<br>$/, '');

      editor.insertHTML(html);
      return false;
    }

    return originalPasteHandler ? originalPasteHandler.call(editor, e) : true;
  };
};
